__turbopack_context__.v({
  "backToTopContainer": "faq-module__KbD-Ta__backToTopContainer",
  "backToTopIcon": "faq-module__KbD-Ta__backToTopIcon",
  "faqButton": "faq-module__KbD-Ta__faqButton",
  "faqButtonContainer": "faq-module__KbD-Ta__faqButtonContainer",
  "faqButtonIcon": "faq-module__KbD-Ta__faqButtonIcon",
  "faqButtonSelected": "faq-module__KbD-Ta__faqButtonSelected",
  "faqGrouping": "faq-module__KbD-Ta__faqGrouping",
  "faqHeadingIcon": "faq-module__KbD-Ta__faqHeadingIcon",
  "pageIndexButtonsModule": "faq-module__KbD-Ta__pageIndexButtonsModule",
  "stillLost": "faq-module__KbD-Ta__stillLost",
  "withStickyButtons": "faq-module__KbD-Ta__withStickyButtons",
  "withoutStickyButtons": "faq-module__KbD-Ta__withoutStickyButtons",
});
